export default "__VITE_ASSET___1X0zzw1__"